// extracted by mini-css-extract-plugin
module.exports = {"titles":"SocialShareModal__titles___114Kf","subtitles":"SocialShareModal__subtitles___2G8uZ","ctas":"SocialShareModal__ctas___-3srF"};